<template>
	<page>
		<module>
			<view-list ref="view"  :work-type="workType" selector :view-config="saasInfo.viewmanage">
				<template #search>
					<m-search ref="search">
						<m-search-item label="采购单号">
							<c-input name="purchase_code"></c-input>
						</m-search-item>
						<m-search-item label="供应商">
                            <c-select name="supplier_id" async  @search="searchSupplier" v-model="supplierId"></c-select>
						</m-search-item>
						<m-search-item label="供应商联系人">
                            <c-select name="supplier_contact_id" async  @search="searchUser('2', arguments[0], arguments[1])"></c-select>
						</m-search-item>
						<m-search-item label="采购部门">
                            <c-select name="purchase_dept_id" async  @search="searchDepartment"></c-select>
						</m-search-item>
						<m-search-item label="采购人">
                            <c-select name="purchase_user_id" async  @search="searchUser('1', arguments[0], arguments[1])"></c-select>
						</m-search-item>
						<m-search-item label="创建人">
                            <c-select name="create_user_id" async  @search="searchUser('1', arguments[0], arguments[1])"></c-select>
						</m-search-item>
						<m-search-item label="创建时间">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
                  <c-button color="main" v-if="auth('b_offline_purchase_edit')" prepend-icon="tf-add"
                            @click="createOrEditPurchaseOrder()">创建采购订单</c-button>
                  <c-button v-if="auth('b_offline_purchase_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

                <template #otherOperate>
                    <c-button v-if="auth('b_offline_purchase_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>

                <!--采购单状态-->
                <template #purchase_state="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_STATE" :value="data.purchase_state"></c-state>
                </template>
                <!--采购单类型-->
                <template #purchase_type="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="data.purchase_type"></c-state>
                </template>
                <!--采购总价-->
                <template #purchase_money="{data}">
                    ￥{{data.purchase_money}}
                </template>
                <!--统计数据-->
                <template #statistic_data="{data}">
                    收 {{data.purchase_product_count}}
                    验 {{data.checked_count}}
                    退 {{data.return_count}}
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="openDetail(data)">查看</c-table-button>
						<c-table-button v-if="auth('b_offline_purchase_edit')" icon="tf-edit" @click="createOrEditPurchaseOrder(data)" :disabled="data.purchase_state != 3">编辑</c-table-button>
						<c-table-button v-if="auth('b_offline_purchase_edit')" icon="tf-trash" color="red" @click="removePurchaseOrder(data)" :disabled="data.purchase_state != 3">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
    import {mapState} from 'vuex'

	export default {
        components: {
        },

        computed: {
            ...mapState(['saasInfo','userInfo'])
        },

        data() {
          return {
              workType:2,
              supplierId:0
          }
        },

		methods: {
            /*******搜索【供应商】下拉框信息*****************/
            searchSupplier(keyword, resolve) {
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: 'SUPPLIER',
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },
            /*******搜索部门*****************/
            searchDepartment(keyword, resolve) {
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: 'DEPARTMENT',
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                });
            },
            /************搜索用户*******************************/
            searchUser(user_type, keyword, resolve) {
                let paramData = {
                    user_type: user_type,
                    options_code: 'SYSUSER',
                    keyword: keyword
                };
                this.request({
                    url: '/system/options',
                    data: paramData,
                    success: data => {
                        resolve(data);
                    }
                })
            },
            /******查看采购单详情，弹窗内初检完成后刷新列表******/
            openDetail(data) {
                this.globalDialog('purchaseDetail', {
                    props: {id: data.id}
                }, () => {
                    //刷新页面
                    this.$refs.view.update();
                });
            },
            /******新增或编辑下线采购单******/
            createOrEditPurchaseOrder(data) {
                this.globalDialog('offlinePurchaseEdit', {
                    data: data
                }, () => {
                    //刷新页面
                    this.$refs.view.update();
                });
            },
            /******删除下线采购单******/
            removePurchaseOrder(data) {
                this.$confirm({
                    title: '确认删除线下采购单？',
                    message: '是否确认删除采购单【'+data.purchase_code+'】？删除后不可恢复，请谨慎操作',
                    resolve: () => {
                        this.request({
                            url: '/purchase/order/remove',
                            data: {
                                purchase_order_id:data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    message: '删除成功'
                                });
                                //刷新页面
                                this.$refs.view.update();
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>
